import { getLocations } from '@/utils/transformers/locations-suggestions'

/* eslint quote-props: ["error", "consistent"] */
const getSuggestionsAdvertiser = (field = '', advertiser = {}) => {
  if (!field) return ''

  const {
    name = '',
    id = '',
  } = advertiser

  const fields = {
    account: {
      name: `${name}`,
      id: `${id}`,
    },
  }

  return fields[field]
}

const getSuggestionsValues = (field = '', items = []) => {
  if (!field) return []

  return items.map(({
    advertiser = {},
  }) => {
    const { id = '', name = '' } = advertiser

    const value = JSON.stringify({ name, id })

    return {
      text: getSuggestionsAdvertiser(field, advertiser),
      value,
    }
  })
}

const getAdvertisersGroup = (locations = [], fieldsText = {}) => {
  const fields = Array.isArray(locations) && locations.reduce((acc, curr) => {
    acc[curr.address.type] = acc[curr.address.type] || []
    acc[curr.address.type].push(curr)
    return acc
  }, {})

  return Object.keys(fields).map((field) => ({
    group: {
      name: field,
      text: fieldsText[field] || '',
    },
    items: getSuggestionsValues(field, fields[field]),
  }))
}

const getAdvertisers = (data = {}, allowedFields = []) => getLocations(data, allowedFields)

export {
  getAdvertisers,
  getAdvertisersGroup,
  getSuggestionsValues,
  getSuggestionsAdvertiser,
}
